import { toast } from "../store/toastStore";
import { translateApiError, type TranslatedError } from "./translateApiError";

export function handleApiError(err: unknown): TranslatedError {
	const translated = translateApiError(err);

	switch (translated.kind) {
		case "toast_warning":
			toast.warning(translated.message);
			break;
		case "reconnect_account":
			toast.warning(translated.message);
			break;
		case "modal":
		case "toast":
		default:
			toast.error(translated.message);
			break;
	}
	return translated;
}

export { translateApiError };
export type { TranslatedError };
